import { Directive, ViewContainerRef } from "@angular/core";

@Directive({
    selector: '[filter-container]'
})
export class FilterContainerDirective{
    constructor(public viewContainerRef: ViewContainerRef){
    }
}